import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';

export default [
  {
    path: '/IFPageSeventyTwoPreLogin',
    name: 'IFPageSeventyTwoPreLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageSeventyTwo/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (from.path === '/IFPageSeventyTwoLogin' || from.path === '/IFPageSeventyTwoLoginSecond') {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageSeventyTwoLogin',
    name: 'pageSeventyTwoLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageSeventyTwo/login.vue'),
  },
  {
    path: '/IFPageSeventyTwoLeaveInfo',
    name: 'pageSeventyTwoLeaveInfo',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageSeventyTwo/leaveInfo.vue'),
  },
  {
    path: '/IFPageSeventyTwoResult',
    name: 'pageSeventyTwoResult',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageSeventyTwo/result.vue'),
  },
  {
    path: '/IFPageSeventyTwoLoading',
    name: 'pageSeventyTwoLoading',
    component: () => import('@/pages/pageListAll/pageSeventyTwo/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageSeventyTwoLoginSecond',
    name: 'pageSeventyTwoLoginSecond',
    component: () => import('@/pages/pageListAll/pageSeventyTwo/loginSecond.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/IFPageSeventyTwoOnline',
    name: 'pageSeventyTwoOnline',
    component: () => import('@/pages/pageListAll/pageSeventyTwo/online.vue'),
    meta: {
      title: '星贷',
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageSeventyTwoLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageSeventyTwoGuide',
    name: 'pageSeventyTwoLoginGuide',
    component: () => import('@/pages/pageListAll/pageSeventyTwo/guide.vue'),
    meta: {
      title: '星贷',
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageSeventyTwoCar',
    name: 'pageSeventyTwoCar',
    component: () => import('@/pages/pageListAll/pageSeventyTwo/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
];
